import { computed, ref, watch } from 'vue';
import { MagicNumberCheckerPlugin } from '../methods/magicNumber';
const MultipleMagicNumberChecks = (acceptedTypes, parsedCallback, resetCallback) => {
    const targetFilesCount = ref(0);
    const parsedFilesCount = ref(0);
    const parsedFiles = ref([]);
    // check file types if its approved
    const approvedTypesList = computed(() => {
        const propsReplaced = acceptedTypes.replace(/[\\.\\/\\*\s]/g, '');
        return propsReplaced.split(',');
    });
    const { parseFile } = MagicNumberCheckerPlugin();
    function checkerCallback(file, isApproved) {
        parsedFilesCount.value += 1;
        // add to the approved file list
        if (isApproved)
            parsedFiles.value = [...parsedFiles.value, file];
    }
    function filesCheck(files) {
        // set how many files should be checked
        // and throw files to the parser to check
        // for valid file types
        targetFilesCount.value = files.length;
        for (let i = 0; i < files.length; i++) {
            parseFile(files[i], approvedTypesList.value, checkerCallback);
        }
    }
    // reset checker and call the callback for resetting
    // the input
    function reset() {
        targetFilesCount.value = 0;
        parsedFilesCount.value = 0;
        parsedFiles.value = [];
        resetCallback();
    }
    watch(parsedFiles, (newValue) => {
        if (!newValue.length)
            return;
        if (targetFilesCount.value > parsedFilesCount.value)
            return;
        // when all files are checked, call the callback function
        // which is the next step in the upload flow
        if (targetFilesCount.value === newValue.length)
            parsedCallback(newValue);
        reset();
    });
    return {
        filesCheck
    };
};
export { MultipleMagicNumberChecks };
